module.exports = {
	"createSeller": "Créer un vendeur",
	"dashboard": {
		"sellers": "Vendeur dans le répertoire"
	},
	"header": "Gestion du système",
	"lastN": "__entryCount__ entrées les plus récentes",
	"uploadSellerLogo": "Vous pouvez maintenant mettre à jour le logo."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/management.json5
// module id = 1992
// module chunks = 6